// extracted by mini-css-extract-plugin
export default {"link":"styles_link__384+l","active":"styles_active__7AFh5"};